import { set, toggle } from '@/utils/vuex'
import { stat } from 'fs'

export default {
  setInitData (state, data) {
    // state.masterAccounts = data.masterAccounts
    state.masterPayers = data.masterPayers
    state.pods = data.pods
  },


  setMasterpayers(state, data) {
    state.masterPayers = data
  },

  setAccountData (state, data) {
    if (state.nextPaginationKey) {
      state.accountData = [
        ...state.accountData,
        ...data
      ]
    } else {
      state.accountData = data
    }
    
  },

  setAccountFilters (state, filters) {
    state.accountDataFilters = {
      ...state.accountDataFilters,
      ...filters
    }
  },

  setSingleAccountFilter (state, filter) {
    const { key, value } = filter
    state.accountDataFilters[key] = value
  },

  setDownloadingAccount (state, loading) {
    state.downloadingAccount = loading
  },

  removeSearchValue (state, filters) {
    state.accountDataFilters['Acct_ID'] = null
    state.accountDataFilters['Acct_Name'] = null
    state.accountDataFilters['Acct_DL'] = null
    state.accountDataFilters['MP_ID'] = null
    state.accountDataFilters['Master_Id'] = null
    state.accountDataFilters['Customer_Id'] = null
  },

  setCustomerAccounts(state, data) {
    state.customerAccounts = data
  },

  setLoadingCustomerAccounts(state, loading) {
    state.loadingCustomerAccounts = loading
  },

  resetAccountFilters(state) {
    state.accountDataFilters = {
      Acct_ID: null,
      Acct_Name: null,
      Acct_DL: null,
      MP_ID: null,
      Customer_Id: null,
      Agreement: 'all',
      Acct_Status: ['New', 'ACTIVE'],
      deleted: "0",
      archived: "0",
      Customer_Owned: 'No',
      DXC_Owned: 'Yes',
    }
  },

  clearAccounts (state) {
    state.accountData = []
  },

  setNextData (state, nextKey) {
    state.nextPaginationKey = nextKey
  },

  clearNextData(state) {
    state.nextPaginationKey = null
  },

  setLoadingAccountData (state, loading) {
    state.loadingAccountData = loading
  },

  deleteAccount (state, id) {
    let recordToBeDeleted = state.accountData.findIndex(record => record.Acct_ID === id)
    state.accountData.splice(recordToBeDeleted, 1)
  },

  restoreAccounts (state, accounts) {
    state.accountData.forEach(function (account, i) {
      if (accounts.includes(account.Acct_ID)) {
        state.accountData.splice(i, 1, { ...account, Del_Flag: 0 })
      }
    })
  },

  setSelectedAgreement (state, aggreementType) {
    state.selectedAgreement = aggreementType
  },

  setInitCustData (state, data) {
    state.customersList = data

    state.breadcrumbs[1].text = state.customersList[0].Customer_Name
  },

  setUpdatedData (state, data) {
    // this.$store.dispatch('accountInventory/initCustomerById')
  },
  loadCustomers (state, customers) {
    state.customers = customers
  },

  loadWorkloadByOppId (state, workloads) {
    state.workloads = workloads
  },
  clearAccountList (state, account) {
    state.account = {}
  },

  addToAccountList (state, account) {
    state.accountData.push(account)
  },

  updateAccountList (state, account) {
    let recordAllToBeUpdatedIndex

    if (account.Acct_ID == 'None') {
      recordAllToBeUpdatedIndex = state.accountData.findIndex(record => record.Onboarding_Id === account.Onboarding_Id)
    } else {
      recordAllToBeUpdatedIndex = state.accountData.findIndex(record => record.Acct_ID === account.Acct_ID)
    }
    let relMasterPayerIndex = state.masterPayers.findIndex(mp => mp.Master_Id === account.Master_Id)
    if (recordAllToBeUpdatedIndex !== -1) {
      state.accountData.splice(recordAllToBeUpdatedIndex, 1, { ...account, MP_ID: state.masterPayers[relMasterPayerIndex].MP_ID })
    }
  },
  updateAccountLists (state, accounts) {
    state.accountData.forEach(function (account, i) {
      if (accounts.Acct_ID.includes(account.Acct_ID)) {
        state.accountData.splice(i, 1, { ...account, Last_Date_Validated: accounts.Last_Date_Validated })
      } else {
        console.log('not success')
      }
    })
  },
  setLastDateValidatedSaving (state, data) {
    state.lastDateValidatedStatus = data
  }
}
